// extracted by mini-css-extract-plugin
export default {"actions":"SupersetInput_actions__UPqkC","placeholder":"SupersetInput_placeholder__tgrma"};